import React from 'react';
import PropTypes from 'prop-types';
import { email } from '@config';
import { Side } from '@components';

const Email = ({ isHome }) => (
  <Side isHome={isHome} orientation="left">
    {/* email-wrapper styles defined in global.css */}
    <div className="email-wrapper">
      <a href={`mailto:${email}`}>{email}</a>
    </div>
  </Side>
);

Email.propTypes = {
  isHome: PropTypes.bool,
};

export default Email;
